module.exports = {
    __esModule: true,
    default: function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.volumeControl)+'" data-hook="volume-control" data-volume-percent="100" data-is-muted="false"> <button class="'+(props.styles.muteButton)+' '+(props.styles.controlButton)+'" data-hook="mute-button" aria-label="'+(props.texts.muteLabel)+'" type="button" tabindex="0"> </button> <div class="'+(props.styles.volumeInputBlock)+'" data-hook="volume-input-block" aria-label="'+(props.texts.volumeLabel)+'" aria-valuemin="0" aria-valuenow="0" aria-valuemax="100" tabindex="0"> <div class="'+(props.styles.progressBar)+' '+(props.styles.background)+' '+(props.themeStyles.volumeProgressBackground)+'"> </div> <div class="'+(props.styles.progressBar)+' '+(props.styles.volume)+' '+(props.themeStyles.volumeProgress)+'" data-hook="volume-input"> </div> <div class="'+(props.styles.hitbox)+'" data-hook="volume-hitbox"> </div> </div></div>';return out;
} 
  };


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/controls/volume/templates/control.dot.js
// module id = 198
// module chunks = 0